module.exports = __webpack_public_path__ + "img/20200106160046360截图20200106110746178.ed3270e4.jpg";